import { call, put, select, takeLatest } from 'redux-saga/effects';
import request from '../../utils/request';
import { push } from 'connected-react-router';
import { API_ROOT } from '../../api-config';
import { fyrkLoaded, deleteFyrk } from './actions';
import { LOAD_FYRK, DELETE_FYRK } from './constants';

/**
 * Github repos request/response handler
 */
const token = localStorage.getItem('token');

const fetchJSON = (url, options = {}) =>
  new Promise((resolve, reject) =>
    fetch(url, options)
      .then(response =>
        response.status !== 201 &&
        response.status !== 200 &&
        response.status !== 400
          ? reject(response)
          : response,
      )
      .then(response => {
        if (response.status == 400) {
          response.json().then(error => reject(error));
        } else {
          return response.json();
        }
      })
      .then(response => {
        resolve(response);
      })
      .catch(error => reject(error)),
  );
export function* removeFyrkRequest(value) {
  const token = localStorage.getItem('token');

  const fyrkId = value.id;
  const requestURL = `${API_ROOT}fyrk/${fyrkId}`;
  try {
    let res = yield call(fetchJSON, `${API_ROOT}fyrk/${fyrkId}/`, {
      credentials: 'omit',
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Token ${token}`,
      },
    });
  } catch (error) {
    throw error;
  }
}
export function* loadFyrk(value) {
  const fyrkId = value.id;
  const requestURL = `${API_ROOT}fyrk/${fyrkId}`;

  try {
    const fyrk = yield call(request, requestURL);
    yield put(fyrkLoaded(fyrk));
  } catch (err) {
    yield put(push('/'));
    // yield put(fyrkerLoadingError(err));
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export default function* githubData() {
  // Watches for LOAD_REPOS actions and calls getRepos when one comes in.
  // By using `takeLatest` only the result of the latest API call is applied.
  // It returns task descriptor (just like fork) so we can continue execution
  // It will be cancelled automatically on component unmount
  yield takeLatest(DELETE_FYRK, removeFyrkRequest);

  yield takeLatest(LOAD_FYRK, loadFyrk);
}
